import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLocation } from "react-router-dom";

export default function RouteExperience() {
  const location = useLocation();
  const [transitionKey, setTransitionKey] = useState(0);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    setTransitionKey((key) => key + 1);
  }, [location.pathname]);

  return (
    <AnimatePresence>
      <motion.div
        key={transitionKey}
        className="route-ignition"
        initial={{ opacity: 0.95, scaleX: 0 }}
        animate={{ opacity: 0, scaleX: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.72, ease: [0.22, 1, 0.36, 1] }}
        aria-hidden="true"
      />
    </AnimatePresence>
  );
}
